import { Link } from "react-router-dom";

const SideNavbar = () => {
  return (
    <>
      <nav
        id="sidebarMenu"
        class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse"
      >
        <div class="position-sticky pt-3">
          <ul class="nav flex-column">
            <li class="nav-item">
              <Link
                to={"./dashboard"}
                aria-current="page"
                class="nav-link active"
              >
                <span data-feather="home"></span>
                Dashboard
              </Link>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Generate QR Codes
              </a>
              <ul class="dropdown-menu">
                <li>
                  <Link to={"./contact-qrcode"} class="dropdown-item">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to={"./url-qrcode"} class="dropdown-item">
                    URL
                  </Link>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Convert Files
              </a>
              <ul class="dropdown-menu">
                <li>
                  <Link to={"./word-pdf-converter"} class="dropdown-item">
                    Word to PDF
                  </Link>
                </li>
                <li>
                  <Link to={"./pdf-word-converter"} class="dropdown-item">
                    PDF to Word
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default SideNavbar;
